import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { CraftRow } from "../models/Craft";

export const fetchCrafts = async (): Promise<CraftRow[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[MMS].[GetCrafts]", []);
	if (!resp.ok) throw new Error(resp.message || "Error fetching crafts");

	return get(resp, "data.tables[0].rows", []) as CraftRow[];
};

export const upsertCraft = async (craft: CraftRow) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "CraftId", value: craft.CraftId },
		{ name: "CraftName", value: craft.CraftName },
		{ name: "Code", value: craft.Code || null },
		{ name: "Color", value: craft.Color },
	];

	const resp = await apiService.callV2("[MMS].[UpsertCraft]", parameters);
	if (!resp.ok) throw new Error(resp.message || "Error saving the craft");
};

export const deleteCraft = async (craftId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "CraftId", value: craftId }];

	const resp = await apiService.callV2("[MMS].[DeleteCraft]", parameters);
	if (!resp.ok) throw new Error(resp.message || "Error deleting the craft");
};
